<template>
  <div
    class="flex w-full items-center justify-center cursor-pointer umami--click--button-launch-iti"
    @click="loadItineraireSearch()"
  >
    <div
      class="flex items-center border-gray-300 dark:border-slate-500 rounded-full px-4 bg-white dark:bg-transparent dark:text-white text-sm"
      style="border-width: 1px"
    >
      <div class="py-2">
        {{ this.title || this.defaultTitle }}
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "ItineraireInfo",
  props: {
    title: String
  },
  data() {
    return {
      defaultTitle: "🌟 Nouveau : Chercher un itinéraire (bêta)"
    };
  },
  methods: {
    loadItineraireSearch() {
      this.$store.commit("clearItineraire");
      this.$router.push({
        name: "itineraire"
      });
    }
  }
};
</script>
